<template>
<div>
	<project-quotes v-if="!quoteSlug"></project-quotes>
	<project-quote v-else
		:quote-slug="quoteSlug"
		v-on:slugChange="setSlug">
	</project-quote>
</div>
</template>
<script type="text/javascript">
import ProjectQuote from "./quoting/ProjectQuote"
import ProjectQuotes from "./quoting/ProjectQuotes"

export default {
	name: "ServiceInvoice",
	components: {
		ProjectQuote,
		ProjectQuotes
	},
	mixins: [],
	data() {
		return {
			listView: true,
			quoteSlug: null
		}
	},
	watch: {

	},
	computed: {

	},
	methods: {
		setSlug(slug) {
			this.quoteSlug = slug
		}
	},
	created() {
		if ("tag" in this.$route.params) {
			this.quoteSlug = this.$route.params.tag
			this.listView = false
		}
	}
}
</script>